import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, ICustomPageContactInfoDto } from '@/dtos';

import { ClaimsProcessor, formatClaimsProcessorPayload } from './ClaimsProcessors.types';

interface Props {
  searchString?: string;
  enabled?: boolean;
}

const useGetAppealEligibleProcessorsQuery = ({ searchString, enabled = true }: Props) => {
  const { isLoading, data, isSuccess } = useQuery(
    [API_URL.CONTACTS_APPEAL_ELIGIBLE, enabled],
    () => api.get<ICustomPageContactInfoDto>(API_URL.CONTACTS_APPEAL_ELIGIBLE, { params: { size: 200 } }),
    { enabled }
  );

  const claimsProcessors = useMemo<ClaimsProcessor[]>(() => {
    if (!data?.data) return [];
    const { content = [] } = data.data;
    const all: ClaimsProcessor[] = content.map((item) => formatClaimsProcessorPayload(item));
    if (!searchString) return all;
    const lower = searchString.toLowerCase();
    return all.filter((p) => p.fullName?.toLowerCase().includes(lower));
  }, [data, searchString]);

  return { claimsProcessors, isLoading, isSuccess };
};

export default useGetAppealEligibleProcessorsQuery;
